import { PUBLIC_URL } from '../../utils/constants';

export default {
  GENERATE_SMK_SITEMAP: `${PUBLIC_URL}/smk_generateSitemap`,
  GENERATE_TPZ_SITEMAP: `${PUBLIC_URL}/theparentz_generateSitemap`,

  MISMATCH_SMK_SITEMAP: `${PUBLIC_URL}/smk_mismatch-sitemap`,
  MISMATCH_TPZ_SITEMAP: `${PUBLIC_URL}/tpz_mismatch-sitemap`,

  QR_CODE_GENERATOR: `${PUBLIC_URL}/tools/qr-code-generator`,
  UTM_BUILDER: `${PUBLIC_URL}/tools/utm-builder`,
  LOCALHOST_FORMATTER_GENERATOR: `${PUBLIC_URL}/tools/localhost-formatter`,
};
